export class Address {
    street;
    unitNumber;
    postcode;
    city;
    assign(other) {
        Object.assign(this, other);
    }
}
